import fetch from "auth/FetchInterceptor";

const ReportService = {};

ReportService.CandidateReport = async function (params) {
  return fetch({
    url: "/Report/CandidateReport",
    method: "get",
    params,
  });
};
ReportService.AgencyReport = async function () {
  return fetch({
    url: "/Report/AgencyReport",
    method: "get",
  });
};
ReportService.VacancyReport = async function () {
  return fetch({
    url: "/Report/VacancyReport",
    method: "get",
  });
};
ReportService.ExportCandidateToExcel = async function (data) {
  return fetch({
    url: "/Report/ExportCandidateToExcel",
    method: "post",
    data,
    responseType: "blob",
  });
};

ReportService.ExportAgencyToExcel = async function (data) {
  return fetch({
    url: "/Report/ExportAgencyToExcel",
    method: "post",
    data,
    responseType: "blob",
  });
};

ReportService.ExportVacancyToExcel = async function (data) {
  return fetch({
    url: "/Report/ExportVacancyToExcel",
    method: "post",
    data,
    responseType: "blob",
  });
};

export default ReportService;
